import { createContext, useState } from "react";

const QuarterlyPageImagesContext = createContext();

const QuarterlyPageImagesProvider = ({ children }) => {
  const [images, setImages] = useState([]);

  const addImage = (item) => {
    setImages((prev) => [...prev, item]);
  };

  const removeImages = () => {
    setImages([]);
  };

  return (
    <QuarterlyPageImagesContext.Provider
      value={{ images, addImage, removeImages }}
    >
      {children}
    </QuarterlyPageImagesContext.Provider>
  );
};

export { QuarterlyPageImagesContext, QuarterlyPageImagesProvider };
